import React, { CSSProperties, memo, useMemo } from 'react';

import { TestProps } from '../../internal/types/testTypes';
import { LoadingIndicatorProps } from '../../internal/types/loadingIndicatorTypes';
import { cn } from '../../lib/css/className/className';

import './Stub.css';

const cls = cn('Stub');

export type StubBorderRadius = '4' | '8' | '14' | '16' | 'round';
export type StubWidth = CSSProperties['width'];
export type StubHeight = Exclude<CSSProperties['height'], undefined>;

export interface StubProps extends TestProps, LoadingIndicatorProps {
    /**
     * Высота элемента
     */
    height: StubHeight;

    /**
     * Ширина элемента
     * @default 'auto'
     */
    width?: StubWidth;

    /**
     * Максимальная ширина элемента
     */
    maxWidth?: StubWidth;

    /**
     * Скругление углов элемента
     * @default '4'
     */
    borderRadius?: StubBorderRadius;

    /**
     * Названия классов для элемента.
     */
    className?: string;
}

export const Stub = memo<StubProps>(function Stub({
    className,
    width = 'auto',
    maxWidth,
    height,
    borderRadius = '4',
    isLoadingIndicator = true,
    ...props
}) {
    const style = useMemo<CSSProperties>(() => ({ height, width, maxWidth }), [height, width, maxWidth]);
    return (
        <span
            style={style}
            className={cls({ borderRadius }, [className])}
            data-testid={props['data-testid']}
            data-loading-indicator={isLoadingIndicator || undefined}
        />
    );
});
